import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7526 1.34151C19.1162 1.75715 19.0741 2.38891 18.6585 2.75259L10.9359 9.50987C10.4411 9.94284 9.72195 10.0031 9.16198 9.6585L5.51852 7.41637L2.55045 9.37334C2.08937 9.67735 1.46914 9.55002 1.16513 9.08893C0.861117 8.62785 0.988448 8.00762 1.44953 7.70361L4.68357 5.57128C5.17029 5.25036 5.79888 5.24054 6.2954 5.54609L9.89627 7.762L17.3415 1.24744C17.7571 0.883755 18.3889 0.925872 18.7526 1.34151Z"
      fill="#595959"
    />
    <path
      d="M1 13.5503C1 13.2077 1.17546 12.8889 1.46495 12.7055L4.60825 10.7148C5.29145 10.2821 6.16799 10.3034 6.82934 10.7688L8.70438 12.0883C9.46348 12.6224 10.4903 12.5641 11.1841 11.9475L15.6713 7.95886C16.9611 6.81237 19 7.72798 19 9.45368V18C19 18.5523 18.5523 19 18 19H2C1.44772 19 1 18.5523 1 18V13.5503Z"
      fill="url(#paint0_linear_1517_7888)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1517_7888"
        x1="1"
        y1="7.00006"
        x2="1"
        y2="19.0001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B9B9B9" />
        <stop offset="1" stopColor="#7B7B7B" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

const activedIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7526 1.34151C19.1162 1.75715 19.0741 2.38891 18.6585 2.75259L10.9359 9.50987C10.4411 9.94284 9.72195 10.0031 9.16198 9.6585L5.51852 7.41637L2.55045 9.37334C2.08937 9.67735 1.46914 9.55002 1.16513 9.08893C0.861117 8.62785 0.988448 8.00762 1.44953 7.70361L4.68357 5.57128C5.17029 5.25036 5.79888 5.24054 6.2954 5.54609L9.89627 7.762L17.3415 1.24744C17.7571 0.883755 18.3889 0.925872 18.7526 1.34151Z"
      fill="#2D64FF"
    />
    <path
      d="M1 13.5503C1 13.2077 1.17546 12.8889 1.46495 12.7055L4.60825 10.7148C5.29145 10.2821 6.16799 10.3034 6.82934 10.7688L8.70438 12.0883C9.46348 12.6224 10.4903 12.5641 11.1841 11.9475L15.6713 7.95886C16.9611 6.81237 19 7.72798 19 9.45368V18C19 18.5523 18.5523 19 18 19H2C1.44772 19 1 18.5523 1 18V13.5503Z"
      fill="url(#paint0_linear_1517_7658)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1517_7658"
        x1="-1.1012"
        y1="6.53418"
        x2="-2.28757"
        y2="20.9185"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B3EE" />
        <stop offset="1" stopColor="#2BCAFF" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconTrend() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
